module.exports = __webpack_public_path__ + "static/media/fte-meditate-thumbnail.6a4e6bcf.png";